import { render } from "./CalendarView.vue?vue&type=template&id=05d46af2&scoped=true&ts=true"
import script from "./CalendarView.vue?vue&type=script&lang=ts"
export * from "./CalendarView.vue?vue&type=script&lang=ts"

import "./CalendarView.vue?vue&type=style&index=0&id=05d46af2&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d46af2"]])

export default __exports__